import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {get} from "../../network/axiosServices";


const initialState = {
    loading: false,
    posts: [],
    error: '',
    detail: [],
    detailLoading: false,
    detailError: ''
}

export const fetchConcernExternal = createAsyncThunk("fetchConcernExternal", (params) => {
    return get(params);
});

export const fetchPageDataExternal = createAsyncThunk("fetchConcernPageExternal", (params) => {
    return get(params);
});
export const fetchConcernDetailExternal = createAsyncThunk("fetchDataDetailExternal", (params) => {
    return get(params);
});


const postSlice = createSlice({
    name: 'concernexternal',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchConcernExternal.pending, (state) => {
            state.loading = true
            state.posts = []
            state.error = ''
        })
        builder.addCase(fetchConcernExternal.fulfilled, (state, action) => {
            state.loading = false
            state.posts = action.payload
            state.error = ''
        })
        builder.addCase(fetchConcernExternal.rejected, (state, action) => {
            state.loading = false
            state.posts = []
            state.error = action.error
        })
        builder.addCase(fetchPageDataExternal.pending, (state) => {
            state.loading = true
            state.page_data = []
            state.error = ''
        })
        builder.addCase(fetchPageDataExternal.fulfilled, (state, action) => {
            state.loading = false
            state.page_data = action.payload
            state.error = ''
        })
        builder.addCase(fetchPageDataExternal.rejected, (state, action) => {
            state.loading = false
            state.page_data = []
            state.error = action.error
        })
        builder.addCase(fetchConcernDetailExternal.pending, (state, action) => {
            state.detailLoading = true
            state.detail = []
            state.detailError = ''
        })
        builder.addCase(fetchConcernDetailExternal.fulfilled, (state, action) => {
            state.detailLoading = false
            state.detail = action.payload
            state.detailError = ''
        })
        builder.addCase(fetchConcernDetailExternal.rejected, (state, action) => {
            state.detailLoading = false
            state.detail = []
            state.detailError = action.error
        })
    }
})


export default postSlice.reducer
